<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-21 10:18:18
-->
<template>
  <!-- 育苗 -->
  <div class="content-wrap">
    <div class="login-box">
      <el-input
        placeholder="输入账号"
        v-model="username"
      />
      <el-input
        placeholder="输入密码"
        type="password"
        v-model="pwd"
      />
      <el-select
        v-model="role"
        placeholder="选择角色"
      >
        <el-option
          v-for="(item, i) in roleList"
          :key="i"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button
        type="button"
        @click="login()"
      >点击登录</el-button>
    </div>
  </div>
</template>

<script>
import http from "../../axios/index";
import * as cookieServ from "@/utils/methods/cookie";
export default {
  name: "login",
  components: {},
  data() {
    return {
      username: "13828280598",
      pwd: "123456",
      role: "0",
      roleList: [
        { id: "0", name: "总裁桌面" },
        { id: "1", name: "中层管理桌面" },
      ],
    };
  },
  computed: {},
  methods: {
    login() {
      const creds = {
        userCode: this.username,
        userPassword: this.pwd,
      };
      http.post("/user/login", creds).then((re) => {
        if (re.code == "0000") {
          this.$store.dispatch("app/setToken", re.data.token);
          cookieServ.addCookie("token", re.data.token);
          // 获取顶级机构Id全局存储
          cookieServ.getCookie("token") &&
            http.get("/desktopReport/queryTopInstitution").then((res) => {
              if (res.code == "0000") {
                res && localStorage.setItem("rootId", res.data.rootId);
                res &&
                  localStorage.setItem("rootOrgName", res.data.rootOrgName);
                res && localStorage.setItem("orgId", res.data.orgId);
                res && localStorage.setItem("orgName", res.data.orgName);
                if (this.role == "0") {
                  this.$router.push("/yc");
                } else {
                  this.$router.push("/day");
                }
              }
            });
        } else {
          this.$message.error(re.msg);
          this.$router.push("/");
        }
      });
    },
  },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {},
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
.login-box {
  /deep/.el-input,
  .el-select,
  .el-button {
    margin-top: 20px;
    margin-left: 50%;
  }
}
</style>